import {
  ApolloLink,
  Observable,
  type FetchResult,
  type Operation,
} from '@apollo/client';

const inflight = new Map<string, Observable<FetchResult>>();

function dedupeKey(operation: Operation): string {
  const name =
    operation.operationName ||
    (operation.query.definitions[0] as { name?: { value?: string } })?.name
      ?.value ||
    'anonymous';
  const shopId =
    (operation.getContext() as { headers?: Record<string, string> })?.headers?.[
      'x-hasura-shop-id'
    ] ?? '';
  let vars = '';
  try {
    vars = JSON.stringify(operation.variables ?? {});
  } catch {
    vars = String(operation.variables);
  }
  return `${name}|${shopId}|${vars}`;
}

/**
 * Coalesces identical in-flight operations (StrictMode double-mount, parallel hooks).
 */
export const inflightDedupeLink = new ApolloLink((operation, forward) => {
  const key = dedupeKey(operation);
  const existing = inflight.get(key);
  if (existing) {
    return existing;
  }

  const stream = new Observable<FetchResult>(observer => {
    const sub = forward(operation).subscribe({
      next: v => observer.next(v),
      error: e => {
        inflight.delete(key);
        observer.error(e);
      },
      complete: () => {
        inflight.delete(key);
        observer.complete();
      },
    });
    return () => sub.unsubscribe();
  });

  inflight.set(key, stream);
  return stream;
});
